import {
  faFilter,
  faFilterCircleXmark,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Popover, PopoverContent } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { FilteringValue } from '../../types/filtering'

export const FilterButton = ({
  filter,
  onFilter,
  renderFilter,
}: {
  filter: FilteringValue
  onFilter: (value: FilteringValue) => void
  renderFilter: (props: {
    filter: FilteringValue
    onFilter: (value: FilteringValue) => void
  }) => JSX.Element
}) => {
  const { t } = useTranslation()

  const getIcon = () => {
    if (filter) return faFilterCircleXmark
    return faFilter
  }

  return (
    <Popover
      renderContent={() => (
        <PopoverContent width="10rem" clearStyles noMarginBottom>
          {renderFilter({ filter, onFilter })}
        </PopoverContent>
      )}
    >
      <Button
        label="sort"
        title={t('Filter')}
        size="xs"
        type="blank-default"
        hideLabel
        icon={<FontAwesomeIcon icon={getIcon()} />}
      />
    </Popover>
  )
}
